(function () {
  'use strict';

  var picker = document.querySelector('[data-cc-initial-picker]');
  if (!picker) return;

  var maxSlots = parseInt(picker.dataset.maxSlots, 10) || 5;
  var countSelector = picker.querySelector('[data-cc-count-selector]');
  var slotsContainer = picker.querySelector('[data-cc-slots]');
  var grid = picker.querySelector('[data-cc-letter-grid]');
  var removeBtn = picker.querySelector('[data-cc-remove-btn]');
  var hiddenInput = picker.querySelector('[data-cc-initials-input]');

  // count  = chosen N (0 = none chosen yet). letters = fixed array of length
  // count, each entry '' (empty box) or an A-Z letter. activeBox = the box the
  // next letter fills / that the A-Z grid targets. It is ALWAYS a valid index
  // while count > 0, and null only when there are no boxes.
  //
  // gridOpen: the A-Z grid shows while there are still empty boxes to fill, and
  // auto-CLOSES once every box is filled. Picking a letter fills the active box
  // and auto-advances to the next empty box (grid stays); when none remain the
  // grid closes. Tapping any box (filled or empty) reopens the grid with that box
  // active, so shoppers can edit a completed selection. No outside-click dismiss.
  var count = 0;
  var letters = [];
  var activeBox = null;
  var gridOpen = false;

  // First still-empty box in [0, count), or -1 if every box is filled.
  function nextEmptyBox() {
    for (var i = 0; i < count; i++) { if (!letters[i]) return i; }
    return -1;
  }

  // --- Order-data contract (LOCKED — must stay byte-identical to legacy) ---
  // 1. Hidden input name="properties[Initials]", value = filled letters joined
  //    by a single space (e.g. "M R K").
  // 2. Event "cc:initials-changed", detail = { count, initials }.
  // 3. count emitted MUST equal the number of real letters at add-to-cart time.
  //    We achieve this by emitting count 0 while ANY box is empty (so the
  //    switcher's Gate 1 keeps ATC disabled), and emitting the full N only when
  //    every box is filled — at which point N === filled letters, exactly as
  //    the legacy add-one-at-a-time picker behaved for a complete selection.
  // cc-variant-switcher.js consumes only detail.count and the hidden input; it
  // must not be touched.
  function emit() {
    var filled = letters.filter(Boolean);
    var allFilled = count > 0 && filled.length === count;

    hiddenInput.value = window.ccJoin(filled);
    // Blank posts NO key (shared helper; never touches the name attribute).
    // Initials are required wherever this picker renders, so the ATC gate
    // already stops an empty value reaching the cart — this keeps the
    // no-blank-properties contract true regardless.
    window.ccSubmitWhenFilled(hiddenInput);

    // Two decoupled signals (see contract above):
    //   count        — gates ATC + drives the committed variant. Stays 0 until
    //                   every box is filled, then equals N. UNCHANGED behaviour.
    //   selectedCount — the picked number N, used by the switcher for the price
    //                   PREVIEW only. Never gates ATC, never commits a variant.
    document.dispatchEvent(new CustomEvent('cc:initials-changed', {
      detail: {
        count: allFilled ? count : 0,
        selectedCount: count,
        initials: filled.slice()
      }
    }));
  }

  function renderCountSelector() {
    if (!countSelector) return;
    countSelector.querySelectorAll('[data-cc-count]').forEach(function (btn) {
      var isOn = parseInt(btn.dataset.ccCount, 10) === count;
      btn.classList.toggle('is-selected', isOn);
      btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
    });
  }

  function renderSlots() {
    slotsContainer.innerHTML = '';

    for (var i = 0; i < count; i++) {
      var letter = letters[i] || '';
      var slot = document.createElement('button');
      slot.type = 'button';
      slot.className = 'cc-initial-picker__slot ' +
        (letter ? 'cc-initial-picker__slot--filled' : 'cc-initial-picker__slot--active');
      if (activeBox === i) slot.className += ' is-editing';
      slot.textContent = letter;
      slot.dataset.index = i;
      slot.setAttribute('aria-label', letter
        ? 'Initial ' + letter + '. Tap to change or remove.'
        : 'Empty box ' + (i + 1) + '. Tap to choose a letter.');
      (function (idx) {
        slot.addEventListener('click', function (e) { e.stopPropagation(); setActiveBox(idx); });
      })(i);
      slotsContainer.appendChild(slot);
    }
  }

  function render() {
    renderCountSelector();
    renderSlots();

    // Grid shows while incomplete (gridOpen), closes when every box is filled.
    grid.hidden = !gridOpen;
    // Gold clear/remove only shows when the active box holds a letter.
    removeBtn.hidden = activeBox === null || !letters[activeBox];

    emit();
  }

  function setCount(n) {
    if (n === count) return;
    if (n < count) {
      // Lowering N: drop the last box(es) and their letters, keep the rest.
      letters = letters.slice(0, n);
    } else {
      while (letters.length < n) letters.push('');
    }
    count = n;
    // Point at the first fillable box and open the grid; if the new count is
    // already fully filled (e.g. lowering N), close it. Null/closed at count 0.
    if (count === 0) {
      activeBox = null;
      gridOpen = false;
    } else {
      var e = nextEmptyBox();
      if (e === -1) { activeBox = count - 1; gridOpen = false; }
      else { activeBox = e; gridOpen = true; }
    }
    render();
  }

  // Re-point which box the grid fills AND (re)open it — used when the shopper
  // taps a box to edit it, including a filled box on a completed selection.
  function setActiveBox(index) {
    activeBox = index;
    gridOpen = true;
    render();
    grid.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  if (countSelector) {
    countSelector.querySelectorAll('[data-cc-count]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        setCount(parseInt(this.dataset.ccCount, 10));
      });
    });
  }

  grid.querySelectorAll('[data-cc-letter]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (activeBox === null) return;
      var wasEditing = !!letters[activeBox];
      letters[activeBox] = this.dataset.ccLetter;
      // Filling forward vs editing. Advancing is only ever right when this pick
      // FILLED an empty box: then move to the next empty one and keep the
      // panel open so a run of picks needs no taps in between. If the shopper
      // deliberately reopened an already-filled box to change it, jumping
      // them somewhere else afterwards is worse than doing nothing - so close
      // the panel and leave them where they were. Either way the panel closes
      // once nothing is left empty.
      if (wasEditing) {
        gridOpen = false;
      } else {
        var e = nextEmptyBox();
        if (e !== -1) { activeBox = e; }
        else { gridOpen = false; }
      }
      render();
    });
  });

  removeBtn.addEventListener('click', function () {
    // Clears the active box back to empty (does not remove the box — count is
    // fixed), keeps it active and reopens the grid for a re-pick.
    if (activeBox !== null && letters[activeBox]) {
      letters[activeBox] = '';
      gridOpen = true;
      render();
    }
  });

  // Single-slot mode (data-cc-init-count present, no count selector rendered):
  // skip the "how many" step. Draw the one box with the A-Z grid open so the
  // shopper just picks a letter; it closes once the box is filled.
  var initCount = parseInt(picker.dataset.ccInitCount, 10);
  if (initCount > 0) {
    count = initCount;
    letters = [];
    while (letters.length < count) letters.push('');
    activeBox = 0;
    gridOpen = true;
  }
  render();
})();
